import { useState, useRef } from 'react';
import styled from 'styled-components';
import { colors } from '../../Components/StylesGlobales/Colors';
import emailjs from '@emailjs/browser';
import SocialIconsForm from '../../Components/SocialNetworks/SocialIconsForm';

const Contact = (props) => {
  const initialState = {
    name: '',
    email: '',
    message: '',
    checkedTerms: false,
  };

  const [contactDates, setContactDates] = useState(initialState);
  const [emptyInputs, setEmptyInputs] = useState(false);
  const [successSendForm, setSuccessSendForm] = useState(false);
  const [errorSendForm, setErrorSendForm] = useState(false);

  const form = useRef();

  const onSubmit = (e) => {
    e.preventDefault();
    setErrorSendForm(false);
    setEmptyInputs(false);

    if (
      contactDates.name === '' ||
      contactDates.email === '' ||
      contactDates.message === '' ||
      contactDates.checkedTerms === false
    ) {
      setEmptyInputs(true);
    } else {
      emailjs
        .sendForm(
          process.env.REACT_APP_EMAILJS_SERVICE_ID,
          process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
          form.current,
          process.env.REACT_APP_EMAILJS_PUBLIC_USER_ID
        )
        .then(
          (result) => {
            setSuccessSendForm(true);
          },
          (error) => {
            setErrorSendForm(true);
          }
        );
    }
  };

  return (
    <div className={props.className}>
      <div className="ContainerContact" id="contactSection">
        <h2 className="Title"> 👋🏽 Contact me </h2>
        <div className="ContainerForm">
          {successSendForm ? (
            <div className="SucessMessage">The form was sent succesfully!</div>
          ) : (
            <form className="Form" onSubmit={onSubmit} ref={form}>
              <input
                className="InputForm"
                placeholder="Your name"
                type="text"
                name="name"
                onChange={(e) =>
                  setContactDates({ ...contactDates, name: e.target.value })
                }
                value={contactDates.name}
              />
              <input
                className="InputForm"
                placeholder="Your email"
                type="email"
                name="email"
                onChange={(e) =>
                  setContactDates({ ...contactDates, email: e.target.value })
                }
                value={contactDates.email}
              />
              <textarea
                className="InputForm"
                placeholder="Write your message"
                name="message"
                onChange={(e) =>
                  setContactDates({ ...contactDates, message: e.target.value })
                }
                value={contactDates.message}
              />
              <div className="ContainerConditions">
                <input
                  type="checkbox"
                  onChange={(e) =>
                    setContactDates({
                      ...contactDates,
                      checkedTerms: e.target.checked,
                    })
                  }
                />
                <span>Accept the terms and conditions</span>
              </div>
              <button className="button" type="submit">
                Send
              </button>
            </form>
          )}
          {emptyInputs && (
            <p className="TextError">
              You should fill all the inputs and accept the terms
            </p>
          )}
          {errorSendForm && (
            <div className="TextError">There was an error, try it later.</div>
          )}
        </div>
        <SocialIconsForm />
      </div>
    </div>
  );
};

export default styled(Contact)`
  .ContainerContact {
    padding-top: 7rem;
    @media (max-width: 768px) {
      padding-top: 5rem;
    }
  }

  .Title {
    text-align: center;
    font-size: 30px;
    margin-bottom: 1rem;
  }

  .ContainerForm {
    max-width: 500px;
    border-radius: 10px;
    box-shadow: 0 0 12px rgb(0 0 0 / 16%);
    padding: 2rem;
    margin: 0 auto;
    background-color: #eee;
    @media (max-width: 768px) {
    }
  }

  .Form {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .InputForm,
  .TextArea {
    padding: 0.5rem;
    border-radius: 6px;
    border: 2px solid #4c526838;
    background-color: transparent;
    font-size: 14px;
    font-family: fantasy;
    display: block;
    width: 90%;
    margin-bottom: 1rem;
    color: #4c5268;
  }

  .button {
    color: ${colors.TEXT_WHITE};
    box-shadow: ${colors.BOX_SHADOW};
    background: linear-gradient(135deg, #6699ff 0%, #ff3366 100%);
    padding: 10px 40px;
    border-radius: 999px;
    border: none;
    margin-top: 1rem;
    font-weight: 700;
    cursor: pointer;
    width: 150px;
    text-transform: uppercase;
  }

  .ContainerConditions {
    display: flex;
    justify-content: start;
    align-items: center;
    gap: 1rem;
    span {
      font-size: 12px;
      color: ${colors.TEXT_BLACK};
    }
  }

  .TextError {
    margin-top: 1rem;
    font-size: 14px;
    text-align: center;
    font-style: italic;
    color: #ff3366;
  }

  .SucessMessage {
    color: #99d41c;
    font-weight: bold;
    font-size: 16px;
    text-align: center;
  }
`;
